import { LanguageStateInterface } from '.';

function state(): LanguageStateInterface {
  return {
    languages: [],
  };
}

export default state;
